import Image from '@components/ui/image'
import { Heading, Text } from '@components/ui/typography'
import { urlFor } from '@lib/sanity/url-for'
import React, { FC } from 'react'
import { SanityAsset } from 'sanity-codegen'
import * as styles from './styles'
import { useInView } from 'react-intersection-observer'

type MemberProps = {
  name: string
  role: string
  image: SanityAsset
}

export const Member: FC<MemberProps> = ({ name, role, image }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })
  return (
    <li className={styles.block} ref={ref} data-visible={inView ? 'visible' : 'hidden'}>
      <Image
        ratio={[1]}
        placeholderSrc={urlFor(image).width(20).url()}
        sources={[urlFor(image).width(640).url()]}
        alt=""
      />
      <Heading variant="h5" as="h3" className={styles.heading}>
        {name}
      </Heading>
      <Text variant="bodySmall" color="shade400">
        {role}
      </Text>
    </li>
  )
}
